var _rect, _path, _path2, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSaveBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 11C17.3358 11 17 11.3358 17 11.75V12.75C17 13.1642 17.3358 13.5 17.75 13.5C18.1642 13.5 18.5 13.1642 18.5 12.75V11.75C18.5 11.3358 18.1642 11 17.75 11Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 27H12C10.3431 27 9 25.6569 9 24V12C9 10.3431 10.3431 9 12 9H21V9.00982C21.7068 9.06715 22.3735 9.37354 22.8787 9.87868L26.1213 13.1213C26.6839 13.6839 27 14.447 27 15.2426V24C27 25.6569 25.6569 27 24 27ZM24 25.5H23V20C23 18.8954 22.1046 18 21 18H15C13.8954 18 13 18.8954 13 20V25.5H12C11.1716 25.5 10.5 24.8284 10.5 24V12C10.5 11.1716 11.1716 10.5 12 10.5V14C12 15.1046 12.8954 16 14 16H19C20.1046 16 21 15.1046 21 14V10.5197C21.3079 10.5702 21.5946 10.7159 21.818 10.9393L25.0607 14.182C25.342 14.4633 25.5 14.8448 25.5 15.2426V24C25.5 24.8284 24.8284 25.5 24 25.5ZM21.5 20V25.5H14.5V20C14.5 19.7239 14.7239 19.5 15 19.5H21C21.2761 19.5 21.5 19.7239 21.5 20ZM19.5 10.5H13.5V14C13.5 14.2761 13.7239 14.5 14 14.5H19C19.2761 14.5 19.5 14.2761 19.5 14V10.5Z",
    fill: "#777777"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 4.5,
    stroke: "#BBBBBB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveBorder);
export default __webpack_public_path__ + "static/media/saveBorder.098b67b2ae853aabde796b49a55a4fab.svg";
export { ForwardRef as ReactComponent };